<ng-container *rxFor="let item of tree; trackBy: trackItem">
    @if (isSeparator(item)) {
        <div class="separator-item">{{ item.title }}</div>
    } @else if (isLeaf(item)) {
        <ng-container *ngTemplateOutlet="leafTemplate || itemTemplate; context: { $implicit: item, class: 'leaf-item' }" />
    } @else {
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }" />
        @if (item.expanded) {
            <ms-item-tree [tree]="item.children" [level]="level + 1" [leafTemplate]="leafTemplate" (toggle)="childToggled($event)" />
        }
    }
</ng-container>

<ng-template #itemTemplate let-item let-class="class">
    <ms-item
        [class]="class"
        [class.active]="item.active"
        [class.expanded]="item.children.length && item.expanded"
        [class.collapsed]="item.children.length && !item.expanded"
        [arrow]="item.arrow || item.children.length"
        [attribute]="item.attribute"
        [count]="(!item.children.length || !item.expanded) && item.count"
        [href]="item.children.length ? undefined : item.href"
        [icon]="item.icon"
        [title]="item.title"
        [tracking]="item.tracking"
        (click)="clicked($event, item)">
        @if (esportsItemTemplate) {
            <div esports-header-content class="esports-header">
                <div class="header-content">
                    <div class="header-title">
                        @if (item.icon) {
                            <span [class]="'icon ' + item.icon"></span>
                        }
                        {{ item.title }}
                    </div>
                    <div class="header-description">{{ sitecore.eSports.CompetitionsByRegion }}</div>
                </div>

                <div class="go-to" (click)="linkClicked($event, item)">
                    <a [href]="item.href">{{ sitecore.eSports.GoToPage }}<span class="theme-right"></span></a>
                </div>
            </div>
        }
        @if (item.regions?.length) {
            <ms-multiple-flags item-icon [regionIds]="item.regions" />
        }
    </ms-item>
</ng-template>
